import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import ScrollToTop from './ScrollToTop'
import i18n from './i18n'
import { I18nextProvider } from 'react-i18next'
import ToastNotification from './components/layouts/ToastNotification'

document.body.classList.add('is_dark')
localStorage.setItem('theme', 'is_dark')

const Loading = () => {
    return <div>Loading...</div>
}

ReactDOM.render(
    <BrowserRouter>
        <ScrollToTop />
        <I18nextProvider i18n={i18n} defaultNS={'translation'}>
            <Suspense fallback={<Loading />}>
                <ToastNotification />
                <App />
            </Suspense>
        </I18nextProvider>
    </BrowserRouter>,
    document.getElementById('root'),
)
